module.exports = __webpack_public_path__ + "pc/img/main-work-img-06.cee87125.png";